import { frontendURL } from '../../../helper/URLHelper';
import SicargDashboardIndex from './Index.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/sicarg-dashboard'),
    name: 'sicarg_dashboard_index',
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
    component: SicargDashboardIndex,
  },
];

export default { routes };
